"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverCursor = void 0;
var gsap_1 = require("gsap");
require("./main.css");
var HoverCursor = /** @class */ (function () {
    function HoverCursor(options) {
        var _this = this;
        this.mothers = document.querySelectorAll(options.containerQuery) || null;
        this.snapPosition = options.snapPosition || 'M';
        this.callbackFunction = options.toggledFunction;
        this.activeTitle = options.title;
        this.activeIcon = options.icon;
        if (this.mothers === null) {
            console.error('No containerQuery specified!');
            return;
        }
        this.mothers.forEach(function (mother) {
            var cursorElement = _this.registerCustomCursor(options.customClass || '');
            mother.appendChild(cursorElement); // <- Add cursor to mother
            _this.snapCustomCursor(cursorElement); // <- Snap cursor to initial position
            mother.style.position = 'relative'; // <- Set mother to relative position to allow absolute positioning of cursor
            mother.addEventListener('mouseenter', function () {
                mother.style.cursor = 'none'; // <- Hide default cursor
            });
            mother.addEventListener('mouseleave', function () {
                _this.snapCustomCursor(cursorElement); // <- Snap cursor to snapPosition (snap mode)
            });
            mother.addEventListener('mousemove', function (event) {
                _this.updateCursorPosition(cursorElement, event, mother); // <- Update cursor position on mousemove (dog mode)
            });
            mother.addEventListener('click', function () {
                _this.activeTitle = _this.activeTitle === options.title ? options.toggledTitle : options.title;
                _this.activeIcon = _this.activeIcon === options.icon ? options.toggledIcon : options.icon;
                _this.toggleCustomCursorContent(mother); // <- Toggle cursor on click
                if (_this.callbackFunction) {
                    _this.callbackFunction();
                } // <- Function to be called on click specified in options
            });
        });
    }
    HoverCursor.prototype.updateCursorPosition = function (cursorElement, event, mother) {
        var x = event.clientX, y = event.clientY; // <- Get mouse position from MouseEvent
        var containerRect = mother.getBoundingClientRect(); // <- Get container position and size
        var containerScaleX = gsap_1.gsap.getProperty(mother, 'scaleX');
        var containerScaleY = gsap_1.gsap.getProperty(mother, 'scaleY');
        var containerTransformX = gsap_1.gsap.getProperty(mother, 'x');
        var containerTransformY = gsap_1.gsap.getProperty(mother, 'y');
        // Calculate the actual position within the scaled and transformed container
        var containerX = (x - containerRect.left - containerTransformX) / containerScaleX; // <- Calculate cursor X position within container
        var containerY = (y - containerRect.top - containerTransformY) / containerScaleY; // <- Calculate cursor Y position within container
        // cursorElement.style.left = `${containerX}px` // <- Set cursor X position
        // cursorElement.style.top = `${containerY}px` // <- Set cursor Y position
        gsap_1.gsap.to(cursorElement, { left: "".concat(containerX, "px"), top: "".concat(containerY, "px"), duration: 0.2 }); // <- Animate cursor to cursor position. NOTE: This may cause performance issues on slower devices! Use the commented lines above instead if this is the case. :)
    };
    HoverCursor.prototype.snapCustomCursor = function (cursorElement) {
        // Snap cursor to snapPosition (snap mode) - note we do not use right or bottom here as we do not want to override the transform origin or any previously calculated transform values
        switch (this.snapPosition) {
            case 'L':
                gsap_1.gsap.to(cursorElement, { left: '10%', top: '50%', duration: 0.2 });
                break;
            case 'M':
                gsap_1.gsap.to(cursorElement, { left: '50%', top: '50%', duration: 0.2 });
                break;
            case 'R':
                gsap_1.gsap.to(cursorElement, { left: '90%', top: '50%', duration: 0.2 });
                break;
        }
    };
    HoverCursor.prototype.registerCustomCursor = function (customClass) {
        // Create elements
        var cursor = document.createElement('div');
        var cursorTitle = document.createElement('p');
        var cursorIcon = document.createElement('img');
        // Add classes
        customClass ? cursor.classList.add("hover-cursor", customClass) : cursor.classList.add("hover-cursor");
        cursorTitle.classList.add("hover-cursor--title");
        cursorIcon.classList.add('hover-cursor--icon');
        if (this.activeIcon) {
            cursorIcon.src = this.activeIcon;
            cursorIcon.alt = 'Custom cursor icon';
            cursorIcon.width = 35;
            cursorIcon.height = 35;
        }
        // Add content
        cursorTitle.innerHTML = this.activeTitle || '';
        // Append elements
        cursor.appendChild(cursorTitle);
        cursor.appendChild(cursorIcon);
        return cursor;
    };
    HoverCursor.prototype.toggleCustomCursorContent = function (mother) {
        // Get cursor elements
        var cursor = mother.querySelector('div.hover-cursor');
        if (cursor === null) {
            console.error('Cursor not found, please open an issue at https://github.com/rps-code/hover-cursor if you see this.');
            return;
        }
        var cursorTitle = cursor.querySelector('p.hover-cursor--title');
        var cursorIcon = cursor.querySelector('img.hover-cursor--icon');
        if (cursorTitle === null || cursorIcon === null) {
            console.error('cursorTitle or cursorIcon not found, please open an issue at https://github.com/rps-code/hover-cursor if you see this.');
            return;
        }
        // Update cursor content to active states
        cursorTitle.innerHTML = this.activeTitle || '';
        // Manage the icon class list
        cursorIcon.src = this.activeIcon || '';
    };
    return HoverCursor;
}());
exports.HoverCursor = HoverCursor;
